module.exports = __webpack_public_path__ + "static/img/PETER_TAYLOR.cd34d07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PETER_TAYLOR.jpg
// module id = m/mn
// module chunks = 0